import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import ModuleHero from './components/ModuleHero';
import LessonsList from './components/LessonsList';
import LessonContent from './components/LessonContent';
import ModuleSummary from './components/ModuleSummary';
import PracticalChecklist from './components/PracticalChecklist';
import SelfAssessment from './components/SelfAssessment';
import Footer from '../home/components/Footer';

export default function Module2Page() {
  const [selectedLesson, setSelectedLesson] = useState<number | null>(null);
  const [showSummary, setShowSummary] = useState(false);
  const [showChecklist, setShowChecklist] = useState(false);
  const [showTest, setShowTest] = useState(false);

  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Navbar />
      <ModuleHero />
      
      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-12 gap-8">
          {/* Sidebar con lista de lecciones */}
          <div className="lg:col-span-4">
            <div className="sticky top-24">
              <LessonsList 
                selectedLesson={selectedLesson}
                onSelectLesson={setSelectedLesson}
              />
              
              <div className="mt-8 space-y-3">
                <button
                  onClick={() => {
                    setShowSummary(true);
                    setSelectedLesson(null);
                    setShowChecklist(false);
                    setShowTest(false);
                  }}
                  className={`w-full px-6 py-4 rounded-xl font-medium transition-all whitespace-nowrap cursor-pointer ${
                    showSummary
                      ? 'bg-[#1A3A2E] text-white'
                      : 'bg-white border border-gray-200 text-gray-700 hover:border-[#39FF14]'
                  }`}
                >
                  📋 Resumen Ejecutivo
                </button>
                
                <button
                  onClick={() => {
                    setShowChecklist(true);
                    setSelectedLesson(null);
                    setShowSummary(false);
                    setShowTest(false);
                  }}
                  className={`w-full px-6 py-4 rounded-xl font-medium transition-all whitespace-nowrap cursor-pointer ${
                    showChecklist
                      ? 'bg-[#1A3A2E] text-white'
                      : 'bg-white border border-gray-200 text-gray-700 hover:border-[#39FF14]'
                  }`}
                >
                  ✅ Checklist Práctico
                </button>
                
                <button
                  onClick={() => {
                    setShowTest(true);
                    setSelectedLesson(null);
                    setShowSummary(false);
                    setShowChecklist(false);
                  }}
                  className={`w-full px-6 py-4 rounded-xl font-medium transition-all whitespace-nowrap cursor-pointer ${
                    showTest
                      ? 'bg-[#39FF14] text-black'
                      : 'bg-white border border-gray-200 text-gray-700 hover:border-[#39FF14]'
                  }`}
                >
                  🎯 Autoevaluación
                </button>
              </div>
            </div>
          </div>

          {/* Contenido principal */}
          <div className="lg:col-span-8">
            {selectedLesson !== null && (
              <LessonContent lessonNumber={selectedLesson} />
            )}
            
            {showSummary && <ModuleSummary />}
            {showChecklist && <PracticalChecklist />}
            {showTest && <SelfAssessment />}
            
            {selectedLesson === null && !showSummary && !showChecklist && !showTest && (
              <div className="bg-white rounded-2xl p-12 border border-gray-200 text-center">
                <div className="w-20 h-20 bg-[#F5F2EB] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-book-open-line text-4xl text-[#1A3A2E]"></i>
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">
                  Selecciona una lección para comenzar
                </h3>
                <p className="text-gray-600 max-w-md mx-auto">
                  Elige cualquier lección del menú lateral para acceder al contenido completo, 
                  ejemplos prácticos y aplicaciones reales.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}